module.exports = __webpack_public_path__ + "img/whatsapp.14447352.svg";